import {index} from '../../api/endpoints/manager'

export const state = {
  data: []
}

export const getters = {
  items(state) {
    return state.data
  }
}

export const mutations = {
  FETCH_DATA(state, payload) {
    state.data = payload.data
  }
}

export const actions = {
  fetchData({commit}, params) {
    return new Promise((resolve, reject) => {
      index({...params}).then( res => {
        commit("FETCH_DATA", res.data);
        resolve(res);
      }).catch(e => {
        reject(e)
      })
    })
  }
}